import { React, useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import s from "./SettingData.module.css"
import * as Yup from 'yup';
import { useUser } from '../../Context/UserContext';
import { createGateway } from '../../Api/ChirpStackApi'
import { getFormattedDeviceList } from '../../Api//DevicesApi'
import { createUser } from '../../Api/UserApi'
import { SubmitButtonForm } from '../shared/SubmitButtonForm'
import { useFormik } from 'formik';
import { TextField, Select, FormControl, InputLabel, MenuItem, Typography, Autocomplete } from '@mui/material';
import { ROLES } from '../../constants/constants';

export const useHideMessage = (submitStatus, setSubmitStatus, setErrorMessage) => {
    useEffect(() => {
        if (submitStatus === 'success' || submitStatus === 'error') {
            const timer = setTimeout(() => {
                setSubmitStatus(null);
                setErrorMessage(null);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [submitStatus, setSubmitStatus, setErrorMessage]);
};

export const GatewayForm = () => {
    const { user } = useUser();


    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            name: "",
            gatewayId: "",
            description: "",
            tenantId: "",
            statsInterval: 60,
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createGateway(values);

                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            }
        }
    })

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);


    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Создание шлюзов
            </Typography>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <TextField
                fullWidth
                margin="normal"
                id="name"
                name="name"
                label="Название"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
            />
            <TextField
                fullWidth
                margin="normal"
                id="gatewayId"
                name="gatewayId"
                label="Идентификатор шлюза (EUI64)"
                value={formik.values.gatewayId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.gatewayId && Boolean(formik.errors.gatewayId)}
                helperText={formik.touched.gatewayId && formik.errors.gatewayId}
            />
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Название организации</InputLabel>
                <Select
                    fullWidth
                    margin="normal"
                    id="tenantId"
                    name="tenantId"
                    label="Название организации"
                    value={formik.values.tenantId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.tenantId && Boolean(formik.errors.tenantId)}
                    helperText={formik.touched.tenantId && formik.errors.tenantId}
                >
                    {user.organization.map(org => (
                        <MenuItem value={org.cs_org_id} key={org._id}>{org.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>

    );
}

export const CreateUserForm = () => {
    const { user } = useUser();
    const [devices, setDevice] = useState([]);

    useEffect(() => {
        async function fetchDevice() {
            try {
                const formatted = await getFormattedDeviceList();
                setDevice(formatted);
            } catch (error) {
                console.error('Error fetching devices:', error.message);
            }
        }
        fetchDevice();
    }, []);

    const formik = useFormik({
        initialValues: {
            password: "",
            email: "",
            fullname: "",
            phonenumber: "",
            role: "",
            organization: [],
            group: [],
            device_number: []
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createUser(values);
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            }
        }
    })


    let availableRoles = [];
    switch (user.role) {
        case 'ADMIN_CHIRPSTACK':
            availableRoles = ROLES;
            break;
        case 'ADMIN_SERVER':
            availableRoles = ROLES.filter(role => role.value !== 'ADMIN_CHIRPSTACK');
            break;
        case 'ADMIN_ORG':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER'].includes(role.value));
            break;
        case 'ADMIN_VODOKANAL':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER', 'ADMIN_ORG'].includes(role.value));
            break;
        case 'USER_ORG':
            availableRoles = ROLES.filter(role => !['ADMIN_CHIRPSTACK', 'ADMIN_SERVER', 'ADMIN_ORG', 'ADMIN_VODOKANAL', 'SETTING_ORG'].includes(role.value));
            break;
        default:
            availableRoles = [];
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string().matches(/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/, ('Неправильный е-майл'))
            .required(('Поле обязательно')),
        password: Yup.string().required(('Поле обязательно'))
            .min(8, ('Минимальная длина 8 символов')),
    });

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Создание пользователя
            </Typography>
            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}

            <TextField
                fullWidth
                margin="normal"
                id="email"
                name="email"
                label="Электронная почта"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <TextField
                fullWidth
                margin="normal"
                id="password"
                name="password"
                label="Пароль"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
            />
            <TextField
                fullWidth
                margin="normal"
                id="fullname"
                name="fullname"
                label="Название организации или ФИО"
                value={formik.values.fullname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.fullname && Boolean(formik.errors.fullname)}
                helperText={formik.touched.fullname && formik.errors.fullname}
            />
            <TextField
                fullWidth
                margin="normal"
                id="phonenumber"
                name="phonenumber"
                label="Телефон"
                value={formik.values.phonenumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.phonenumber && Boolean(formik.errors.phonenumber)}
                helperText={formik.touched.phonenumber && formik.errors.phonenumber}
            />
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Роль пользователя</InputLabel>
                <Select
                    fullWidth
                    margin="normal"
                    id="role"
                    name="role"
                    label="Роль пользователя"
                    value={formik.values.role}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.role && Boolean(formik.errors.role)}
                >
                    {availableRoles.map(role => (
                        <MenuItem key={role.value} value={role.value}>{role.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            {formik.values.role === 'USER' && (
                <Autocomplete
                    sx={{ marginTop: '16px' }}
                    multiple
                    id="tags-outlined"
                    options={devices}
                    getOptionLabel={(option) => `${option.dev_number} - ${option.address}`}
                    filterSelectedOptions
                    onChange={(event, value) => {
                        formik.setFieldValue('device', value.map(item => item.dev_id));
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Устройства"
                            placeholder="Выберите устройства"
                        />
                    )}
                />
            )}

            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Организация</InputLabel>
                <Select
                    fullWidth
                    margin="normal"
                    id="organization"
                    name="organization"
                    multiple
                    label="Организация"
                    value={formik.values.organization}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.organization && Boolean(formik.errors.organization)}
                    helperText={formik.touched.organization && formik.errors.organization}
                >
                    {user.organization.map(org => (
                        <MenuItem value={org.id} key={org.id}>{org.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств</InputLabel>
                <Select
                    fullWidth
                    margin="normal"
                    id="group"
                    name="group"
                    multiple
                    label="Группа устройств"
                    value={formik.values.group}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.group && Boolean(formik.errors.group)}
                    helperText={formik.touched.group && formik.errors.group}
                >
                    {user.group.map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}

